import React from 'react';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
import { LANGUAGE_NAMES, DEFAULT_LANGUAGE } from '../../../../service/constants';

const StatusSection = ({ enabled, onEnabledChange, lang, show = true }) => {
    if (!show) return null;
    
    const languageLabel = LANGUAGE_NAMES[lang] || "";
    const languageSuffix = ` (${languageLabel})`;
    
    return (
        <div className="form-group">
            <label>Estado{languageSuffix}</label>
            <ButtonGroup toggle className="w-100">
                <ToggleButton
                    key="hidden"
                    type="radio"
                    variant="outline-primary"
                    name={`status-${lang}`}
                    value={false}
                    checked={!enabled}
                    onChange={(e) => onEnabledChange(false)}
                >
                    Oculto
                </ToggleButton>
                <ToggleButton
                    key="visible"
                    type="radio"
                    variant="outline-primary"
                    name={`status-${lang}`}
                    value={true}
                    checked={enabled}
                    onChange={(e) => onEnabledChange(true)}
                >
                    Visible
                </ToggleButton>
            </ButtonGroup>
        </div>
    );
};

export default StatusSection;
